export class CdCardTypes {

    static ArContractTypeID = "51596f1c-1829-40f4-b471-22c45a3978fd";
    static ArPowerOfAttorneyTypeID = "188211f8-2b2c-4ce0-a446-206e31d20fdf";
    static ArPowersOfAttorneyAuthorityTypeID = "0622e1af-e91f-4663-a37b-d586323587cb";
    static ArDocumentIdpTypeID = "8ef44c17-a3c6-4af4-9930-d34c4e5edcb3";
    static TechnicalDocumentationTypeID = "56de2e2d-a374-49b8-9639-a4cf7742a1d7";
    static PkExecutiveDocumentationTypeID = "70557f03-c6ab-4b62-a855-e6f513fae9b8";
    static PkExecutiveSchemeTypeID = "57087b16-185f-49e2-bcb0-24f8bd13547a";
    static PkDevelopmentScenarionTypeID = "5bb2dcd3-2f50-4214-89bb-da4503e5afe0";
    static PkRequestForMaterialsTypeID = "a28b3be6-c406-42e5-8647-60a6e3d0ea42";
    static PkCaseNewTypeID = "d57a5f2f-67f2-4ff8-a01e-5f022367c2d7";
    static RdDivisionRoleTypeID = "9f01a70a-fb62-4ddc-9c18-db928d243173";
    static ProjectTypeID = "c613dbdc-f52e-411c-a004-8f061688fec6";
    static PkKCKPartnerTypeID = "43d2051c-b7d7-47d9-ad69-623ae6513579";
    static PersonalRoleTypeID = "929ad23c-8a22-09aa-9000-398bf13979b2";
    static PkGlazingOrderTypeID = "a669b8e6-ebbb-4d86-a263-c09a0c48a359";
    static PkAdditionalWorksContractOrderTypeID = "c60ab7e3-82e8-43dc-8c03-e689b422c71a";
    static PkZosRvDocumentypeID = "092e84c3-1072-4db8-9a7d-911ad42078b5";

    static ArPowersOfAttorneyAuthorityTypeName = "ArPowersOfAttorneyAuthority";

    static ArHeadersBlanksForPowerOfAttorneyTypeID = "cce01cf4-8c23-44a8-96be-a6fa55739e6f";
    static ArFinanceTaxAuthorityRegistrationTypeID = "0425989a-061d-4409-950c-5057d82d1e39";

    // из другого модуля, не удалось разделить
    static PkIncomingTypeID = "0ca52091-fd54-4e72-bfba-b31ca18de901";
    static PkMemoTypeID = "debdbddb-030b-433b-b8df-8cf98a72344e";
    static PkOutgoingTypeID = "9485e570-954a-4d90-bbc7-6610fe9674e4";
    static RdndTypeID = "1b61abab-6643-40bd-852f-c7b0753b72aa";
    static PkInternalDocumentationTypeID = "65e9d23f-551c-4386-b49f-c0eb40c693fa";
    static PkAssignmentTypeID = "11929c1b-0aa0-48c8-99bc-2058378647cc";
    static PkLetterCreditTypeID = "10a3e047-6943-45df-8779-8a832a205978";
    static InstructionTypeID = "bb3719cc-5033-4c95-92ec-01411c170b97";
    static ArActTypeID = "29ea1af0-4cd0-4a34-9184-8dc275672e1a";
    static PkProtocolTenderTypeID = "d85b4a17-2e58-459e-bf80-958ad88a7c56";
    static ArEDocumentTypeID = "ba0c2336-267c-49b8-bb4c-78cd620cdd82";
    static PkPacketVirtualTypeID = "ae8e3ad3-3e30-4d20-969a-2565bd92c957";
    static PkWorkOrderTypeID = "502955b1-a3ad-4d90-99ea-0205ebc4d139";
    static PkProtocolTypeID = "0abe23f3-0d5a-485b-ba15-64ec86c0296b";
    static PkProxyTypeID = "3b3e09a9-4a17-46e5-b941-6d4afcccac13";
    static PkTCOfferTypeID = "6dca5b3d-7e33-4b30-ad3d-3849a4265ae8";
    static IrdDocumentTypeID = 'c2b8a9a1-16eb-4ada-9842-7709bc236ee1';
    static IrdDocumentTypeName = 'IrdDocument';
    static IrdTEPTypeID = '820516e2-a9fc-49c8-8800-cd163580d11f';
    static IrdTEPTypeName = 'IrdTEP';

    static CopyTileCardTypes: string[] = [
        CdCardTypes.PkExecutiveDocumentationTypeID,
        CdCardTypes.TechnicalDocumentationTypeID,
        CdCardTypes.ArDocumentIdpTypeID,
        CdCardTypes.RdndTypeID,
        CdCardTypes.PkInternalDocumentationTypeID,
        CdCardTypes.PkAssignmentTypeID,
        CdCardTypes.PkMemoTypeID,
        CdCardTypes.PkOutgoingTypeID,
        CdCardTypes.PkIncomingTypeID,
        CdCardTypes.PkLetterCreditTypeID,
        CdCardTypes.ArActTypeID,
        CdCardTypes.PkProtocolTypeID,
        CdCardTypes.ArEDocumentTypeID,
        CdCardTypes.PkProtocolTenderTypeID,
        CdCardTypes.PkWorkOrderTypeID,
        CdCardTypes.PkExecutiveSchemeTypeID,
        CdCardTypes.PkDevelopmentScenarionTypeID,
        CdCardTypes.PkRequestForMaterialsTypeID,
        CdCardTypes.PkGlazingOrderTypeID
    ];

    static TileExecutionAcquaintanceCardTypes: string[] = [
        CdCardTypes.PkExecutiveDocumentationTypeID,
        CdCardTypes.PkExecutiveSchemeTypeID,
        CdCardTypes.PkProtocolTenderTypeID,
        CdCardTypes.PkWorkOrderTypeID
    ];

    static TypesOfDocumentsWithApprovalLists: string[] = [
        CdCardTypes.PkOutgoingTypeID,
        CdCardTypes.PkIncomingTypeID,
        CdCardTypes.PkAssignmentTypeID,
        CdCardTypes.PkMemoTypeID,
        CdCardTypes.RdndTypeID,
        CdCardTypes.InstructionTypeID,
        CdCardTypes.PkLetterCreditTypeID,
        CdCardTypes.ArActTypeID,
        CdCardTypes.PkProtocolTenderTypeID,
        CdCardTypes.PkWorkOrderTypeID,
        CdCardTypes.PkExecutiveDocumentationTypeID,
        CdCardTypes.PkInternalDocumentationTypeID,
        CdCardTypes.PkProtocolTypeID,
        CdCardTypes.TechnicalDocumentationTypeID,
        CdCardTypes.ArEDocumentTypeID,
        CdCardTypes.PkExecutiveSchemeTypeID,
        CdCardTypes.PkDevelopmentScenarionTypeID,
        CdCardTypes.PkRequestForMaterialsTypeID,
        CdCardTypes.PkTCOfferTypeID,
        CdCardTypes.ArContractTypeID,
        CdCardTypes.PkGlazingOrderTypeID
    ];

    static RefsTableSupportedCardTypes: string[] = [
        CdCardTypes.TechnicalDocumentationTypeID,
        CdCardTypes.RdndTypeID,
        CdCardTypes.IrdDocumentTypeID,
        CdCardTypes.PkInternalDocumentationTypeID,
        CdCardTypes.PkAssignmentTypeID,
        CdCardTypes.PkMemoTypeID,
        CdCardTypes.PkOutgoingTypeID,
        CdCardTypes.PkIncomingTypeID,
        CdCardTypes.ArDocumentIdpTypeID,
        CdCardTypes.ArActTypeID,
        CdCardTypes.PkProtocolTenderTypeID,
        CdCardTypes.PkWorkOrderTypeID,
        CdCardTypes.PkProxyTypeID,
        CdCardTypes.PkExecutiveDocumentationTypeID,
        CdCardTypes.ArContractTypeID,
        CdCardTypes.PkProtocolTypeID,
        CdCardTypes.ArEDocumentTypeID,
        CdCardTypes.PkExecutiveSchemeTypeID,
        CdCardTypes.PkDevelopmentScenarionTypeID,
        CdCardTypes.PkRequestForMaterialsTypeID,
        CdCardTypes.PkTCOfferTypeID,
        CdCardTypes.ArPowerOfAttorneyTypeID
    ];
}